module.exports = "build/assets/fade.7e0dc151.png";